import React, { useState } from "react";
import SelectField from "../../../../components/select/selectField";
import Input from "../../../../components/textfield/input";
import MainButton from "../../../../components/button/mainButton";
import EmptyModel from "../../../../components/modal/emptyModal";
import Icon from "@mdi/react";
import { mdiCheckCircleOutline } from "@mdi/js";
import "../../../../assets/styles/admin/personnel.scss";
import { useParams } from "react-router-dom";

interface Prop {
  isHidel?: boolean;
}

interface ParamTypes {
  id: string;
}

const PersonnelPass: React.FC<Prop> = ({ isHidel = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [textModal, setTextModal] = useState("");
  const [isUserName, setUserName] = useState("");
  const [isPassWord, setPassWord] = useState("");
  const [isConFirm, setConFirm] = useState("");
  const [isUserGroup, setUserGroup] = useState("");
  const { id } = useParams<ParamTypes>();

  const optionGroup = [
    { value: "Therapist", name: "Therapist" },
    { value: "Marketing", name: "Marketing" },
    { value: "ผู้บริหาร", name: "ผู้บริหาร" },
    { value: "Operation", name: "Operation" },
    { value: "ผู้ดูแลระบบ", name: "ผู้ดูแลระบบ" },
    { value: "Accounting", name: "Accounting" },
    { value: "CS", name: "CS" },
    { value: "Sale", name: "Sale" },
    { value: "Cashier", name: "Cashier" },
    { value: "Anti Aging", name: "Anti Aging" },
    { value: "IT Support", name: "IT Support" },
    { value: "Sale Cashier JobCost", name: "Sale Cashier JobCost" },
    { value: "Therapist Senior", name: "Therapist Senior" },
    { value: "แม่บ้าน", name: "แม่บ้าน" },
  ];

  const UpDatePassWord = () => {
    console.log("UPDATE PASSWORD SUCCESS => ", isUserGroup);
    console.log("UPDATE PASSWORD SUCCESS => ", isUserName);
    console.log("UPDATE PASSWORD SUCCESS => ", isPassWord);
    console.log("UPDATE PASSWORD SUCCESS => ", isConFirm);
  };

  function onClose() {
    setIsOpen(false);
  }

  return (
    <div>
      <div style={{ padding: "10px 40px" }}>
        <EmptyModel show={isOpen} onClose={onClose}>
          <div className="model-create">
            <Icon path={mdiCheckCircleOutline} color="#86CFC6" size="70" />
            <div className="col-12" style={{ textAlign: "center" }}>
              บันทึกผู้ใช้งานระบบเรียบร้อยแล้ว
            </div>
            <div className="justify-center">
              <MainButton
                className="mg-10"
                width="100px"
                title="ตกลง"
                onClick={() => {
                  UpDatePassWord();
                  setIsOpen(false);
                }}
              />
            </div>
          </div>
        </EmptyModel>
        <div className="create-page" style={{ padding: "20px 80px" }}>
          <div className="title-header">
            <h3>ข้อมูลการเข้าใช้ระบบ</h3>
          </div>
          <div className="row justify-content-around">
            <div className="col-6">
              <SelectField
                title="User Group"
                placeholder="คำนำนายชื่อ"
                option={optionGroup}
                onChange={(e) => setUserGroup(e.target.value)}
              />
            </div>
            <div className="col-6">
              <Input
                title="Username"
                value={isUserName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </div>
          </div>
          <div style={{ marginTop: "50px" }}></div>
          <div className="row justify-content-around">
            <div className="col-6">
              <Input
                title="Password"
                type="text"
                value={isPassWord}
                onChange={(e) => setPassWord(e.target.value)}
              />
            </div>
            <div className="col-6">
              <Input
                title="Confirm"
                type="text"
                value={isConFirm}
                onChange={(e) => setConFirm(e.target.value)}
              />
            </div>
          </div>
        </div>

        {!isHidel && (
          <div className="justify-center mt-20">
            <MainButton className="mg-10" background="#E76464" title="ยกเลิก" />
            <MainButton
              className="mg-10"
              title="บันทึกข้อมูล"
              onClick={() => {
                setIsOpen(true);
                setTextModal("1");
              }}
            />
          </div>
        )}
        {id === undefined ? (
          <div className="justify-center mt-20">
            <MainButton className="mg-10" background="#E76464" title="ยกเลิก" />
            <MainButton
              className="mg-10"
              title="บันทึกข้อมูล"
              onClick={() => {
                setIsOpen(true);
                setTextModal("1");
              }}
            />
          </div>
        ) : undefined}
      </div>
    </div>
  );
};
export default PersonnelPass;
